type ExperimentDescriptor<
  V extends { default: string; [x: string]: string } = { default: string },
> = {
  experiment: string;
  variant: V;
};

const createExperimentDescriptor = <V extends { default: 'default'; [x: string]: string }>(
  id: string,
  variants: V,
): ExperimentDescriptor<V> => ({
  experiment: id,
  variant: variants,
});

export const MONETATE_DEFAULT_VARIANT = 'default';

export const EOS_NEW_HEADER = createExperimentDescriptor('EoS_newHeader', {
  default: MONETATE_DEFAULT_VARIANT,
  showNewHeader: 'showNewHeader',
});

export const monetateExperiments = [EOS_NEW_HEADER];
